// Cart drawer: confirmation without navigation, and the free-shipping meter on
// every page rather than only on /cart.
//
// Before this, adding from a PDP was a full page POST to /cart — the shopper was
// thrown out of the product they were reading, with no way back but the browser
// button, and the meter (the one thing that argues for a second item) lived
// three screens down a page they had to leave the store to see.
//
// Every entry point keeps its no-JS path: the header link still navigates to
// /cart, and the product form still POSTs if this script fails or is absent.
(function () {
  var drawer = document.querySelector('[data-cdrawer]');
  if (!drawer) return;

  var panel = drawer.querySelector('.cdrawer__panel');
  var body = drawer.querySelector('[data-cdrawer-body]');
  var foot = drawer.querySelector('[data-cdrawer-ft]');
  var meter = drawer.querySelector('[data-cdrawer-meter]');
  var meterMsg = drawer.querySelector('[data-cdrawer-meter-msg]');
  var bar = drawer.querySelector('[data-cdrawer-bar]');
  var subEl = drawer.querySelector('[data-cdrawer-subtotal]');
  var title = drawer.querySelector('#cdrawer-title');
  var threshold = parseInt(drawer.dataset.threshold, 10) || 0;
  var lastFocus = null;
  var busy = false;

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function open(headline) {
    lastFocus = document.activeElement;
    if (title && headline) title.textContent = headline;
    drawer.hidden = false;
    // Next frame, so the transform transition has a start value to run from.
    requestAnimationFrame(function () { drawer.classList.add('on'); });
    document.body.style.overflow = 'hidden';
    if (panel) panel.focus();
  }

  function close() {
    drawer.classList.remove('on');
    document.body.style.overflow = '';
    var done = function () { drawer.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else setTimeout(done, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cdrawer-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (drawer.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    // Keep focus inside the dialog while it is modal.
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  function paintCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    // The shortfall follows the shopper around the store instead of hiding on /cart.
    document.querySelectorAll('[data-ship-hint]').forEach(function (n) {
      var rem = threshold - cart.total_price;
      if (!threshold || cart.item_count === 0) { n.hidden = true; return; }
      n.hidden = false;
      n.textContent = rem > 0 ? money(rem) + ' to free shipping' : 'Free shipping unlocked';
    });
  }

  function render(cart) {
    paintCounts(cart);

    if (threshold) {
      meter.hidden = false;
      var rem = threshold - cart.total_price;
      var done = rem <= 0;
      meter.classList.toggle('done', done);
      meterMsg.textContent = done ? 'Free shipping unlocked' : money(rem) + ' more for free shipping';
      bar.style.setProperty('--pct', done ? 100 : Math.round((cart.total_price / threshold) * 100));
    }

    if (!cart.items.length) {
      body.innerHTML = '<p class="cdrawer__empty">Your cart is empty.</p>';
      foot.hidden = true;
      meter.hidden = true;
      return;
    }

    var ul = document.createElement('ul');
    ul.className = 'cdl';
    cart.items.forEach(function (it, i) {
      var li = document.createElement('li');
      li.dataset.line = i + 1;

      var img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      if (it.image) img.src = it.image.replace(/(\.[a-z]+)(\?|$)/i, '_128x128$1$2');
      li.appendChild(img);

      var mid = document.createElement('div');
      var a = document.createElement('a');
      a.className = 'cdl__nm';
      a.href = it.url;
      a.textContent = it.product_title;
      mid.appendChild(a);
      if (it.variant_title) {
        var v = document.createElement('span');
        v.className = 'cdl__var';
        v.textContent = it.variant_title;
        mid.appendChild(v);
      }
      var qty = document.createElement('div');
      qty.className = 'cdl__qty';
      qty.innerHTML =
        '<button type="button" data-cd-qty="-1" aria-label="Decrease quantity"' + (it.quantity <= 1 ? ' disabled' : '') + '>–</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-cd-qty="1" aria-label="Increase quantity">+</button>';
      mid.appendChild(qty);
      var rm = document.createElement('button');
      rm.type = 'button';
      rm.className = 'cdl__rm';
      rm.dataset.cdRemove = '1';
      rm.textContent = 'Remove';
      mid.appendChild(rm);
      li.appendChild(mid);

      var p = document.createElement('span');
      p.className = 'cdl__p';
      p.textContent = money(it.final_line_price);
      li.appendChild(p);

      ul.appendChild(li);
    });
    body.innerHTML = '';
    body.appendChild(ul);

    foot.hidden = false;
    subEl.textContent = money(cart.total_price);
  }

  function refresh(headline) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        if (headline != null) open(headline);
        return cart;
      });
  }

  function change(line, quantity) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { window.location.href = '/cart'; })
      .then(function () { busy = false; });
  }

  body.addEventListener('click', function (e) {
    var li = e.target.closest('[data-line]');
    if (!li) return;
    var line = parseInt(li.dataset.line, 10);
    var step = e.target.closest('[data-cd-qty]');
    if (step) {
      var now = parseInt(li.querySelector('.cdl__qty span').textContent, 10) || 1;
      change(line, now + parseInt(step.dataset.cdQty, 10));
      return;
    }
    if (e.target.closest('[data-cd-remove]')) change(line, 0);
  });

  // Entry point 1: the product form. This is the one that used to navigate.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (!form || form.dataset.fallback) return;
    if (form.classList.contains('pcard__quickadd')) return; // handled by quick-add.js
    e.preventDefault();

    var btns = form.querySelectorAll('[type="submit"], [data-atc]');
    var was = [];
    btns.forEach(function (b, i) { was[i] = b.textContent; b.disabled = true; b.textContent = 'Adding…'; });

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { return refresh('Added to your cart'); })
      .then(function () { btns.forEach(function (b, i) { b.disabled = false; b.textContent = was[i]; }); })
      .catch(function () {
        form.dataset.fallback = '1';
        btns.forEach(function (b, i) { b.disabled = false; b.textContent = was[i]; });
        form.submit();
      });
  });

  // Entry point 2: the header cart link, and anything else opting in.
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cdrawer-open], .site-header__cart');
    if (!t) return;
    e.preventDefault();
    refresh('Your cart');
  });

  // Entry point 3: quick-add on the grids announces its own success.
  document.addEventListener('bmtc:cart-added', function () { refresh('Added to your cart'); });

  // Paint the header hint on load, without opening anything.
  refresh(null).catch(function () {});
})();
